import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './Sidebar.css';

const Sidebar = () => {
  const { user, logout } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const handleLogout = () => {
    setMobileMenuOpen(false);
    logout();
    navigate('/');
  };

  const isActive = (path) => {
    return location.pathname === path;
  };

  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location.pathname]);

  if (!user || user.account_type === 'user') {
    return null;
  }

  return (
    <>
      <button
        type="button"
        className={`sidebar-mobile-toggle ${mobileMenuOpen ? 'active' : ''}`}
        onClick={() => setMobileMenuOpen((open) => !open)}
        aria-label={mobileMenuOpen ? 'Close menu' : 'Open menu'}
        aria-expanded={mobileMenuOpen}
        aria-controls="sidebar-navigation"
      >
        <span></span>
        <span></span>
        <span></span>
      </button>

      <button
        type="button"
        className={`sidebar-overlay ${mobileMenuOpen ? 'visible' : ''}`}
        onClick={() => setMobileMenuOpen(false)}
        aria-label="Close sidebar"
      />

      <aside
        id="sidebar-navigation"
        className={`sidebar ${mobileMenuOpen ? 'mobile-open' : ''}`}
      >
        <div className="sidebar-header">
          <img src="/assets/images/Tickets.gif" alt="Tickets Lord" className="sidebar-logo" />
          <span className="sidebar-title">Tickets Lord</span>
        </div>

        <div className="sidebar-menu">
          <div className="sidebar-section">
            <h3>Dashboard</h3>
            {user.is_admin && (
              <Link to="/" className={isActive('/') ? 'active' : ''}>
                <span className="icon">Hm</span> Home
              </Link>
            )}
            {user.is_admin && (
              <Link to="/browse" className={isActive('/browse') ? 'active' : ''}>
                <span className="icon">Br</span> Browse Events
              </Link>
            )}
          </div>

          {(user.account_type === 'creator' || user.is_admin) && (
            <div className="sidebar-section">
              <h3>Event Management</h3>
              <Link to="/create-event" className={isActive('/create-event') ? 'active' : ''}>
                <span className="icon">+</span> Create Event
              </Link>
              <Link to="/manage-events" className={isActive('/manage-events') ? 'active' : ''}>
                <span className="icon">Mg</span> Manage Events
              </Link>
              <Link to="/live-adverts" className={isActive('/live-adverts') ? 'active' : ''}>
                <span className="icon">Lv</span> Live Adverts
              </Link>
              <Link to="/creator-dashboard" className={isActive('/creator-dashboard') ? 'active' : ''}>
                <span className="icon">Db</span> Creator Dashboard
              </Link>
              <Link to="/revenue" className={isActive('/revenue') ? 'active' : ''}>
                <span className="icon">Rv</span> Revenue
              </Link>
              <Link to="/check-in" className={isActive('/check-in') ? 'active' : ''}>
                <span className="icon">Ci</span> Check-In
              </Link>
            </div>
          )}

          {user.is_admin && (
            <div className="sidebar-section">
              <h3>Administration</h3>
              <Link to="/admin" className={isActive('/admin') ? 'active' : ''}>
                <span className="icon">Ad</span> Admin Dashboard
              </Link>
            </div>
          )}

          <div className="sidebar-section">
            <h3>Account</h3>
            <Link to="/profile" className={isActive('/profile') ? 'active' : ''}>
              <span className="icon">Me</span> Profile
            </Link>
            <button onClick={handleLogout} className="sidebar-logout">
              <span className="icon">Out</span> Logout
            </button>
          </div>

          <div className="sidebar-section">
            <h3>Support</h3>
            <Link to="/support" className={isActive('/support') ? 'active' : ''}>
              <span className="icon">?</span> Support Center
            </Link>
            <Link to="/about" className={isActive('/about') ? 'active' : ''}>
              <span className="icon">i</span> About
            </Link>
            <Link to="/cookie-policy" className={isActive('/cookie-policy') ? 'active' : ''}>
              <span className="icon">Co</span> Cookie Policy
            </Link>
          </div>
        </div>

        <div className="sidebar-footer">
          <div className="user-info">
            <span className="user-role">{user.account_type}</span>
            <span className="user-name">{user.name}</span>
          </div>
        </div>
      </aside>
    </>
  );
};

export default Sidebar;
